<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g transform="translate(0 0)">
      <path
        :class="className"
        d="M28.325,29.627l-8.165.815-2.149,7.091a1.121,1.121,0,0,0,.321,1.164,1.039,1.039,0,0,0,1.163.154L37.39,29.911a1.066,1.066,0,0,0,0-1.889L19.507,19.075a1.039,1.039,0,0,0-1.163.154,1.121,1.121,0,0,0-.321,1.164l2.149,7.091,8.149.815a.666.666,0,0,1,0,1.321Z"
        transform="translate(-17.962 -18.963)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: ['className'],
};
</script>

<style>
.a {
  fill: #b5b5b5;
}
</style>
